import axios from "axios";
import { API_BASE_URL } from "../../config/env";
import { getAuthHeaders } from "../../utils/auth";

export function GetUsers(data) {
  let url = `${API_BASE_URL}api/v1/analytics/geographic/extend?`;
  if (data.city) {
    url += `city=${data.city}&`;
  }
  if (data.state) {
    url += `state=${data.state}&`;
  }
  return axios.get(decodeURIComponent(encodeURIComponent(url)), {
    headers: getAuthHeaders(),
  });
}

export function CreateUser(payload) {
  const url = `${API_BASE_URL}api/v1/admin/createUser`;
  return axios.post(url, payload, {
    headers: getAuthHeaders(),
  });
}

export function UpdateUserDeletedStatus(userId, isDeleted) {
  const url = `${API_BASE_URL}api/v1/admin/users/${userId}/deleted-status`;
  return axios.patch(url, { isDeleted }, {
    headers: getAuthHeaders(),
  });
}
